export enum DistanceType {
  Meter = 'METER',
  Kilometer = 'KILOMETER',
  Mile = 'MILE',
  Feet = 'FEET',
}

export const DistanceTypeDisplayName = {
  [DistanceType.Meter]: 'M',
  [DistanceType.Kilometer]: 'KM',
  [DistanceType.Mile]: 'mi',
  [DistanceType.Feet]: 'feet',
};
